// Module
var code = "<div class=\"u-sizeFullWidth ui-grid-cell-contents\">\n    <extension-status status=\"row.entity.CurrentlyActive ? grid.appScope.ExtensionStatus.ACTIVE : grid.appScope.ExtensionStatus.UPCOMING\"></extension-status>\n</div>";
// Exports
module.exports = code;